// extracted by mini-css-extract-plugin
export default {"navSkeletonContainer":"styles_navSkeletonContainer__5Cj+B","navSkeletonItemWrapper":"styles_navSkeletonItemWrapper__ZlOOX","navSkeletonItem":"styles_navSkeletonItem__IlhkU"};